// The rules the server applies to tax brackets (backend/utils/taxBrackets.js),
// checked before saving so a tax is not saved with brackets the server will
// refuse. Returns null or { message, vars } for t().

const toNumber = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : NaN;
};

export function bracketProblem(brackets) {
  if (!Array.isArray(brackets) || brackets.length === 0) return { message: 'At least one bracket is required' };
  let previousMax = null;
  for (let i = 0; i < brackets.length; i++) {
    const n = i + 1;
    const min = toNumber(brackets[i].min_amount);
    const max = toNumber(brackets[i].max_amount);
    const rate = toNumber(brackets[i].tax_rate);
    const last = i === brackets.length - 1;
    if (min === null || Number.isNaN(min) || min < 0) return { message: 'Bracket {n}: min amount must be a number of 0 or more', vars: { n } };
    if (rate === null || Number.isNaN(rate) || rate < 0 || rate > 100) return { message: 'Bracket {n}: tax rate must be between 0 and 100', vars: { n } };
    if (Number.isNaN(max)) return { message: 'Bracket {n}: max amount must be a number or empty', vars: { n } };
    if (i === 0 && min !== 0) return { message: 'Bracket 1 must start at 0' };
    if (i > 0 && min !== previousMax) return { message: 'Bracket {n} must start at {start}, where bracket {prev} ends', vars: { n, start: previousMax, prev: i } };
    if (!last && max === null) return { message: 'Bracket {n}: only the last bracket can have no max amount', vars: { n } };
    if (last && max !== null) return { message: 'Bracket {n}: the last bracket must have no max amount, so all income above it is taxed', vars: { n } };
    if (max !== null && max <= min) return { message: 'Bracket {n}: max amount must be greater than min amount', vars: { n } };
    previousMax = max;
  }
  return null;
}
